import { io } from "socket.io-client";
import { apiSlice } from "../api/apiSlice";

export const messagesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMessages: builder.query({
            query: (id) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,

            transformResponse: (response, meta) => {
                const totalCount =
                    meta?.response?.headers?.get("X-Total-Count");

                return {
                    data: response,
                    totalCount,
                };
            },

            async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                //initialize socket
                const socket = io(
                    "https://chat-app-server-by-saurav.herokuapp.com",
                    {
                        reconnectionDelay: 1000,
                        reconnection: true,
                        reconnectionAttempts: 10,
                        transports: ["websocket"],
                        agent: false,
                        upgrade: false,
                        rejectUnauthorized: false,
                    }
                );

                try {
                    await cacheDataLoaded;
                    socket.on("message", (data) => {
                        updateCachedData((draft) => {
                            const message = draft?.data?.find(
                                (draftMsg) =>
                                    draftMsg?.conversationId ===
                                    data?.data?.conversationId
                            );

                            if (message?.conversationId) {
                                draft?.data?.push(data?.data);
                            }
                        });
                    });
                } catch {
                    await cacheEntryRemoved;
                    socket.close();
                }
            },
        }),

        getMoreMessages: builder.query({
            query: ({ id, page }) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,

            async onQueryStarted({ id }, { queryFulfilled, dispatch }) {
                try {
                    const { data } = (await queryFulfilled) || {};

                    if (data?.length > 0) {
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getMessages",
                                id,
                                (draft) => {
                                    return {
                                        data: [...draft.data, ...data],
                                        totalCount: Number(draft.totalCount),
                                    };
                                }
                            )
                        );
                    }
                } catch (error) {}
            },
        }),

        addMessage: builder.mutation({
            query: (data) => ({
                url: "/messages",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useGetMessagesQuery, useAddMessageMutation } = messagesApi;
